// extracted by mini-css-extract-plugin
export default {"root":"primary-button_root__FfuLa"};